function AvatarCommand() {
  return `........./OOOOOOOOOOOOOOOOOOOOOOOO@@OO@\\.........
......./@@OOOOOO@OO@@OOOO@@O@@@@@@OOOO@@/........
......./OO@@@@@@@@@@@@@@@@@@@@@@@@@OOOOO@\`.......
.......=@O@@@/...,[[OO@@@@O/[[... ,@@@@O@\\.......
......,@O@@@\`  ................... .@@@OO^.......
......./O@@.  ....................  .@@@O@.......
......,@O@^  ....................... =@@@^.......
.......=@@O==@@@\\\`...=....^.,]@@@@@^=\\@@@........
........@@@ ..]]]O@@@@....@O[\\]]]]\`. ,@@@\`.......
....,/[\\/@^  ,/\\@/[[^.......,\\@/[/@.  /@@/[O.....
....@O.\\=@@    ,OOO ........ ,OOO\`   .@@,^.@^....
....@,.,\\@@\` .,[[[[...........[[[[\`  =@^\\.,=^....
....,^\`\\^=@O..........,^............=@@.OO\`@.....
.....,\\=/O@@\\........\\^............,@O@//\\/......
.......,\\]@O@@@@@@@@@@@@@@@@@@@@@@@@O@\\]/\`.......
..........=@O@@@@@/\`.........[@@@@@@O@...........
...........,@OO@@@^...........@@@@OO@\`...........
.............,@@@@@@\\]\\]]O\`,/@@@@@@\`.............
................,\\@@@@@@@@@@@@@@[................
.........]@@@@@@@@\\..[[[[[[[..@@@@@@@@@\\.........
.......=@OO@@OO@@@@\\........,@@@@@@@@OOO@\`.......
.......@OO@@@@@@@@@@@@@@@@@@@@@@@@@@@@OOO@.......
.......@OO@@@@@@@@@@@@@@@@@@@@@@@@@@@@OOO@.......
.......=/[[O@@O@@@@@@@@@@@@@@@@@@@O@@O[[@........
.......=^ ..=@O@@@@@@@@@@@@@@@@@@@O@^.. @........`;
}

export default AvatarCommand;



// WEBPACK FOOTER //
// ./src/commands/AvatarCommand.js